var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], t.indexOf(o) >= 0 || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.indexOf(n) >= 0) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIABright(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 600,
    height: 600,
    viewBox: "0 0 600 600",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_118_2)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M285.513 -73.0858L307.821 -63.6167L315.791 -67L319.295 -58.7462L393.3 -27.3326L389.34 -18.0012H209.377L208 -21.2454L275.707 -49.9854L285.513 -73.0858ZM231.569 53.997L127 300.347V191H4.57764e-05V599.54L-36.5933 685.748L71.1945 731.501L126.165 602H127V600.032L299.358 193.981L531.765 741.498L639.557 695.743L367.151 53.997H231.569ZM127 600.032L126.165 602H4.57764e-05V599.54L127 300.347V600.032ZM62.9985 125.997C97.7916 125.997 125.997 97.7915 125.997 62.9984C125.997 28.2054 97.7916 0 62.9985 0C28.2054 0 4.57764e-05 28.2054 4.57764e-05 62.9984C4.57764e-05 97.7915 28.2054 125.997 62.9985 125.997Z",
    fill: "#BFBFBF"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_118_2"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 600,
    height: 600,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIABright);
export default __webpack_public_path__ + "static/media/iA Bright.febe9779320c79ec954e42b2f4a750e5.svg";
export { ForwardRef as ReactComponent };